module.exports = __webpack_public_path__ + "static/media/girl_talking.fc4d055e.gif";